export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-16 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white">移动观影</h2>
              <p className="text-sm md:text-base text-white/60 mt-4 leading-relaxed max-w-md mx-auto lg:mx-0">
                8090影视移动端App即将上线，随时随地畅享高清电影。支持离线缓存、个性化推荐、弹幕互动等丰富功能，让观影体验更自由。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-6">
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 text-white text-sm cursor-pointer hover:bg-white/20 transition-colors whitespace-nowrap">
                  <i className="ri-apple-line text-lg"></i>
                  App Store 即将上线
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 text-white text-sm cursor-pointer hover:bg-white/20 transition-colors whitespace-nowrap">
                  <i className="ri-android-line text-lg"></i>
                  安卓版 即将上线
                </div>
              </div>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-5 text-white/40 text-xs">
                <span className="flex items-center gap-1"><i className="ri-download-line"></i>离线缓存</span>
                <span className="flex items-center gap-1"><i className="ri-smartphone-line"></i>手机观影</span>
                <span className="flex items-center gap-1"><i className="ri-notification-line"></i>更新提醒</span>
              </div>
            </div>
            <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-8">
              <div className="relative w-[200px] h-[360px] md:w-[240px] md:h-[420px] rounded-2xl overflow-hidden border-2 border-white/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20clean%20modern%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%20layout%2C%20dark%20theme%20with%20warm%20amber%20accents%2C%20minimal%20UI%20design%2C%20on%20a%20dark%20background%2C%20no%20text%20readable&width=480&height=840&seq=app-mockup-8090&orientation=portrait"
                  alt="8090影视移动端App预览"
                  className="w-full h-full object-cover"
                  onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}